import React, { useEffect, useMemo, useRef, useState } from "react";
import { PowerBIEmbed } from "powerbi-client-react";
import { models } from "powerbi-client";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import GoToPage from "../../assets/img/go-to-page.png";
import { Link } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useCustomVisuals } from "../../hooks/useCustomVisuals";
import BarChartLoader from "../layout/BarChartLoader";

const ALL_VALUES = "__ALL__";

const filterKeyOf = (filter) => `${filter?.target?.table}.${filter?.target?.column}`;

/** Match the column's own type: a numeric column rejects "2029" as a string. */
function coerceValue(value, sample) {
  if (typeof sample === "number" || (sample === undefined && /^-?\d+(\.\d+)?$/.test(value))) {
    const asNumber = Number(value);
    if (!Number.isNaN(asNumber)) return asNumber;
  }
  return value;
}



const FiltersVisuals = (props) => {
  const { fetchReportData } = useCustomVisuals();

  const [pbireportsConfig, setpbireportsConfig] = useState();

  const id = props.report_id;

  const pbireports = pbireportsConfig?.data;

  const [isloading, setIsLoading] = useState(true);
  const [Repotisloading, setRepotisloading] = useState(true);
  const [errorData, seterrorData] = useState(false);


  useEffect(() => {
    if (isloading) {
      const fetchViusals = async () => {
        try {
          const json = await fetchReportData(id);
          setpbireportsConfig(json);
          setIsLoading(false);
          seterrorData(false);
        } catch (err) {
          setpbireportsConfig();
          setIsLoading(false);
          seterrorData(true);
        }
      };
      fetchViusals();
    }
  }, [id, isloading]); // eslint-disable-line react-hooks/exhaustive-deps


  // Slicer Filtering -------------------------------------------------

  const embeddingData = pbireports?.embedReport;
  const EmbedUrl = embeddingData?.url;
  const Embedaccess_token = embeddingData?.embedToken;
  const EmbedPBIreport_id = `${embeddingData?.reportGuid}`;
  // Slice captured when an admin added this visual to the persona; replayed here
  // so the tile shows the same numbers it did in the report.
  const savedFilters = useMemo(
    () => (Array.isArray(props.filters) ? props.filters : []),
    [props.filters]
  );
  const filterOptions = useMemo(
    () => (Array.isArray(props.filterOptions) ? props.filterOptions : []),
    [props.filterOptions]
  );

  const [filterDialogOpen, setFilterDialogOpen] = useState(false);
  const [appliedSelections, setAppliedSelections] = useState({});
  const [draftSelections, setDraftSelections] = useState({});

  // Opens on the admin's saved value, so the dropdown reads as the slice the
  // tile is actually rendering.
  useEffect(() => {
    setAppliedSelections(
      Object.fromEntries(
        filterOptions.map((option) => {
          const saved = savedFilters.find((filter) => filterKeyOf(filter) === option.key);
          return [option.key, saved?.values?.[0] !== undefined ? String(saved.values[0]) : ALL_VALUES];
        })
      )
    );
  }, [filterOptions, savedFilters]);

  const personaFilters = useMemo(() => {
    const applied = new Map(savedFilters.map((filter) => [filterKeyOf(filter), filter]));

    filterOptions.forEach((option) => {
      const selected = appliedSelections[option.key];
      if (selected === undefined) return;

      if (selected === ALL_VALUES) {
        applied.delete(option.key);
        return;
      }

      // Built fresh rather than spread over the saved filter: picking a value
      // means "is this value", and inheriting a NotIn operator would turn that
      // into "is not this value".
      const sample = applied.get(option.key)?.values?.[0];
      applied.set(option.key, {
        $schema: "http://powerbi.com/product/schema#basic",
        target: { table: option.table, column: option.column },
        filterType: 1,
        operator: "In",
        values: [coerceValue(selected, sample)],
        requireSingleSelection: false,
      });
    });

    return [...applied.values()];
  }, [savedFilters, filterOptions, appliedSelections]);

  const openFilterDialog = () => {
    setDraftSelections(appliedSelections);
    setFilterDialogOpen(true);
  };

  const applyFilterDialog = () => {
    setAppliedSelections(draftSelections);
    setFilterDialogOpen(false);
  };

  const embeddedVisual = useRef(null);
  const embdData = (TrigerdData) => {
    embeddedVisual.current = TrigerdData;
  };

  // Doubles as the embed's React key: Apply re-embeds the visual with the new
  // filters, which is the only path Power BI honours for every field — an
  // in-place updateFilters is rejected for fields outside the visual's scope.
  const filtersKey = JSON.stringify(personaFilters);

  useEffect(() => {
    setRepotisloading(true);
  }, [filtersKey]);






  return (
    <div style={{ position: "relative", height: "350px" }}>
      {Repotisloading && (
        <div
          style={{
            position: "absolute",
            background: "white",
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            zIndex: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          className="pageLoading"
        >
          <BarChartLoader />
        </div>
      )}

      {!isloading && !errorData && (
        <div style={{ height: "100%" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              paddingBottom: "10px",
              alignItems: "center",
            }}
          >
            <span
              style={{ fontSize: "16px", color: "#253978", fontWeight: "600" }}
            >
              {props.title}
            </span>

            <div
              style={{
                display: "flex",
                paddingBottom: "10px",
                alignItems: "center",
                gridGap: "20px",
                alignContent: "center",
              }}
            >

              {filterOptions.length > 0 && (
                <button
                  type="button"
                  onClick={openFilterDialog}
                  title="Filter this KPI"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                    border: "1px solid #e5e7eb",
                    borderRadius: "6px",
                    background: "#fff",
                    color: "#253978",
                    fontSize: "12px",
                    padding: "2px 8px",
                    cursor: "pointer",
                  }}
                >
                  <FilterAltOutlinedIcon style={{ fontSize: 16 }} />
                  {personaFilters.length > 0 ? personaFilters.length : ""}
                </button>
              )}

              <Link
                id="goToPage"
                style={{ color: "white", textDecoration: "none" }}
                to={`/reports/${props.report_id}/view?ReportSection=${props.report_name}&groupId=${props.groupId}`}
              >
                <img
                  src={GoToPage}
                  title="View Dahsboard"
                  alt="Dashboard"
                  width="16px"
                  style={{ background: "transparent !important" }}
                />
              </Link>
            </div>
          </div>

          <PowerBIEmbed
            key={filtersKey}
            embedConfig={{
              type: "visual", // Supported types: report, dashboard, tile, visual, and qna.
              id: EmbedPBIreport_id,
              embedUrl: EmbedUrl,
              accessToken: Embedaccess_token,
              tokenType: models.TokenType.Embed, // Use models.TokenType.Aad if you're embedding for your organization.
              pageName: `${props.report_name}`,
              visualName: `${props.visuals_id}`,
              filters: personaFilters,
              background: "#ffffff",
              settings: {
                background: models.BackgroundType.Transparent, // or models.BackgroundType.Default
                navContentPaneEnabled: false,
                panes: {
                  filters: {
                    expanded: true,
                    visible: false,
                  },
                },
              },
            }}
            eventHandlers={
              new Map([
                [
                  "loaded",
                  function (event) {
                    // console.log("Report loaded");
                    setRepotisloading(false);
                  },
                ],
                [
                  "rendered",
                  function (event) {
                    // console.log("Report rendered");
                  },
                ],
                [
                  "dataSelected",
                  function (event) {
                    // console.log("Data selected event triggered");
                    // console.log(event.detail);
                  },
                ],
                [
                  "saved",
                  function (event) {
                    // console.log("Report Saved");
                  },
                ],
                [
                  "error",
                  function (event) {
                    // console.log("error");
                  },
                ],
              ])
            }
            cssClassName={"report-style-class"}
            getEmbeddedComponent={embdData}
          />

          <Dialog open={filterDialogOpen} onClose={() => setFilterDialogOpen(false)} maxWidth="xs" fullWidth>
            <DialogTitle style={{ fontSize: "16px", fontWeight: 600, color: "#253978" }}>
              Filter — {props.title}
            </DialogTitle>
            <DialogContent dividers>
              {filterOptions.map((option) => (
                <label
                  key={option.key}
                  style={{ display: "block", marginBottom: "12px", fontSize: "12px", color: "#555" }}
                >
                  {option.column}
                  <select
                    value={draftSelections[option.key] ?? ALL_VALUES}
                    onChange={(event) =>
                      setDraftSelections((prev) => ({ ...prev, [option.key]: event.target.value }))
                    }
                    style={{
                      width: "100%",
                      marginTop: "4px",
                      padding: "6px 8px",
                      border: "1px solid #e5e7eb",
                      borderRadius: "6px",
                      fontSize: "13px",
                      background: "#fff",
                    }}
                  >
                    <option value={ALL_VALUES}>All</option>
                    {option.values.map((value) => (
                      <option key={String(value)} value={value}>
                        {String(value)}
                      </option>
                    ))}
                  </select>
                </label>
              ))}
            </DialogContent>
            <DialogActions>
              <button
                type="button"
                onClick={() => setFilterDialogOpen(false)}
                style={{
                  border: "1px solid #e5e7eb",
                  background: "#fff",
                  borderRadius: "6px",
                  padding: "6px 14px",
                  fontSize: "13px",
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={applyFilterDialog}
                style={{
                  border: "none",
                  background: "var(--app-button-color, #253978)",
                  color: "#fff",
                  borderRadius: "6px",
                  padding: "6px 14px",
                  fontSize: "13px",
                  cursor: "pointer",
                }}
              >
                Apply
              </button>
            </DialogActions>
          </Dialog>
        </div>
      )}

      {!isloading && errorData && (
        <div
          style={{
            display: "grid",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          There Is Some Issue On this Report, Please Contact With Admin Or Try
          Again Later
        </div>
      )}



      <ToastContainer />
    </div>
  );
};

export default FiltersVisuals;
